// Angular + external
import { Component, OnInit } from "@angular/core";
import {
  ConnectionStatusPromiseService,
  ConnectionStatus,
  ConnectionStatusState,
} from "shared/broker-client-services";
import { Subscription } from "rxjs";
// BFX

// services
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxDashboardMenuService } from "../bfx-common/services/bfx-dashboard-menu.service";
import { BfxBlotterOrdersService } from "../bfx-blotter-orders/bfx-blotter-orders.service";
import { BfxAppStatusService } from "../bfx-common/services/bfx-app-status.service";
import { SystemControlStatus, SystemControlImpl } from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";
import { LogoutNotificationService } from "../bfx-auth/logout-notification.service";
import { BfxAuthService } from "../bfx-common/services/bfx-auth.service";

@Component({
  selector: "bfx-nav-menu",
  templateUrl: "./html/bfx-nav-menu.component.html",
  standalone: false,
})
export class BfxNavMenuComponent implements OnInit {
  /***************************************/
  /* DATA */

  public username: string;

  public maximized: boolean = false;

  public get frameTag() {
    return document.body.dataset.frameTag;
  }

  constructor(
    private dashboardMenuService: BfxDashboardMenuService,
    private _logoutNotificationService: LogoutNotificationService,
    private _authService: BfxAuthService,
  ) {}

  ngOnInit() {
    this.username = this._authService.getUsername();

    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      NativeDesktopSupport.getNativeDesktopWindow()
        .isMaximized()
        .then((val) => {
          this.maximized = val;
        });

      NativeDesktopSupport.getNativeDesktopWindow().addEventListener(
        "maximize",
        (() => {
          this.maximized = true;
        }).bind(this),
      );

      NativeDesktopSupport.getNativeDesktopWindow().addEventListener(
        "unmaximize",
        (() => {
          this.maximized = false;
        }).bind(this),
      );
    }
  }

  /**********************************/
  /* PUBLIC Methods */

  public help(): void {
    window.open("https://www.bcdfx.com/confluence/display/bcdfx/3.1+Guides", "help");
  }

  public showMenu(): void {
    this.dashboardMenuService.showHideMenu();
  }

  public get shouldMaximizeMinimize(): boolean {
    return NativeDesktopSupport.isNativeDesktopContainer();
  }

  public get devMode(): boolean {
    return NativeDesktopSupport.isNativeDesktopContainer() && NativeDesktopSupport.devMode;
  }

  public openDevTools(): void {
    NativeDesktopSupport.getNativeDesktopWindow().openDevTools();
  }

  public maximize(): void {
    if (this.maximized) {
      NativeDesktopSupport.getNativeDesktopWindow()
        .restore()
        .then(
          () => logger.out.info(`Window restored successfully`),
          (reason) => logger.out.error(`Error restoring window: ${reason}`),
        );
    } else {
      NativeDesktopSupport.getNativeDesktopWindow()
        .maximize()
        .then(
          () => logger.out.info(`Window maximised successfully`),
          (reason) => logger.out.error(`Error maximising window: ${reason}`),
        );
    }
    this.maximized = !this.maximized;
  }

  public minimize(): void {
    NativeDesktopSupport.getNativeDesktopWindow().minimize();
  }

  public close(): void {
    this._logoutNotificationService.requestLogout().subscribe(
      (logoutAccepted) => {
        if (logoutAccepted) {
          this._authService.logout();
        } else {
          logger.out.warn("not logging out due to component rejection (dialog)?");
        }
      },
      (_) => {
        logger.out.warn("not logging out due to component error (dialog)?");
      },
    );
  }
}
